import { DateTime } from 'luxon';
import { ContractAuditDto, ContractHistoryTargetDto, ContractHistoryValueDto } from './types';

// Audit dates are instants, never date-only values or an assumed local midnight.
export function contractTimestamp(value?: string | null): DateTime | null {
    if (!value || !/T\d{2}:\d{2}.*(?:Z|[+-]\d{2}:?\d{2})$/i.test(value)) {
        return null;
    }
    const parsed = DateTime.fromISO(value, { setZone: true });
    return parsed.isValid ? parsed.toLocal() : null;
}

export function formatContractTimestamp(value?: string | null): string {
    return contractTimestamp(value)?.setLocale('en').toFormat('d MMM yyyy, HH:mm') ?? 'Unavailable';
}

export function contractActorName(userId: string | null | undefined, names: Readonly<Record<string, string>>): string {
    return userId ? names[userId]?.trim() || 'Unknown user' : 'Unavailable';
}

export function isNewContractVersion(audit?: ContractAuditDto | null): boolean {
    return audit?.isHistoryComplete === true && !audit.recordInformation?.lastSaved && audit.historyCount === 0;
}

export function contractLastUpdated(audit?: ContractAuditDto | null) {
    const record = audit?.recordInformation;
    return record?.lastSaved ?? (isNewContractVersion(audit) ? record?.created : null);
}

export function contractHistoryValue(value: ContractHistoryValueDto): string {
    switch (value.kind) {
        case 'NotSet':
            return 'Not set';
        case 'NotPresent':
            return 'Not present';
        case 'Removed':
            return 'Removed';
        case 'Value':
            return value.text ?? 'Unavailable';
        default:
            return 'Unavailable';
    }
}

export function contractHistoryTarget(target: ContractHistoryTargetDto): string {
    return [...(target.context ?? []), target.label || 'Unavailable'].join(' · ');
}
